import { selectCheck, selectChoice, reportCheck, reportVideo} from '../actions'
import React from 'react'
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux'
import {routerActions} from 'react-router-redux'
import Check from '../components/Check'

import { Container,Jumbotron, Row,Col,Button} from 'reactstrap';

import MC from '../components/MC'
import {fetchQuiz} from '../actions'
import {quizID,quiz_path,default_qnum} from '../constants'

export class QuizPage extends React.PureComponent{
  constructor(props) {
		super(props)
		this.Prev = this.Prev.bind(this)
		this.Next = this.Next.bind(this)
	}
	componentWillMount(){
    if(!this.props.isquizready){
      //console.log('fetching!');
	    this.props.fetchQuiz(this.props.quizID)
    }
    else{
      this.handle_out_bound()
    }
	}
	in_bound(){
	  const {qnum,quizsize}=this.props
    if( qnum >=quizsize || qnum<0){
      return false;
    }
    return true;
	}
	handle_out_bound(new_qnum){
	  if(this.props.isquizready && !this.props.in_bound){
      // if it is out_of_bound, go back to 0.    
      var qnum=new_qnum || default_qnum
      this.props.push(quiz_path+qnum)
    }
	}
  //https://github.com/reactjs/react-router-redux/issues/197
	componentDidUpdate(nextProps,nextState){
    //this.handle_out_bound()
	}
	Prev(){
	  const {qnum,quizsize, push}=this.props
	  let newqnum = qnum - 1
    if( newqnum < 0){ //mod
      newqnum = quizsize+qnum-1
    }
    push(quiz_path+newqnum); 
	}
	Next(){
	  const {qnum,quizsize,push}=this.props
	  let newqnum = qnum + 1
    if( newqnum >= quizsize){ //mod
      newqnum=qnum+1 -quizsize
    }
    push(quiz_path+newqnum);
	}
  render(){
    if(this.props.isquizready){ // Ready!
      if(this.props.in_bound){
        const {qnum, qID, qtext, choices,ans, youtubeID, select, correct, selectChoice, reportCheck,reportVideo } = this.props
        return(
          <Container>
            <Jumbotron className="jumbotronquiz">
                <Row className="text-center" >
                    <Col xs="1"/>
                    <Col xs="10">
                      <Button className="text-center" color="primary" size="lg" onClick={this.Prev}>
                          {'<'}
                      </Button> 
                      &nbsp;&nbsp;
                      <Check className="text-center" correct={correct} checkClick={()=>reportCheck(qnum)} />
                      &nbsp;&nbsp;
                      <Button className="text-center" color="primary" size="lg" onClick={this.Next}>
                          {'>'}
                      </Button>
                    </Col>
                    <Col xs="1"/>
                </Row>
                <MC Prev={this.Prev.bind(this)}  Next={this.Next.bind(this)} qnum={qnum} qID={qID} qtext={qtext} youtubeID={youtubeID} onStart={()=>reportVideo(qnum)} ans={ans} choices={choices} select={select} correct={correct} selectChoice={selectChoice}/>
            </Jumbotron>
          </Container>
        )        
      }
      else{ //Out of bound
        return (
          <div><Row className="text-center">Out of bound. Redirect to 0.</Row></div>
        )
      }
    }
    else{ //Not Ready!
      return (
        <div><Row className="text-center">Loading...</Row></div>
      )
    }
  }
}

/*
// KWANG - We use two values to determine whether QuizPage is ready for rendering.  
  isquizready for quizset :
    fetching and setuping the state for quiz.

  in_bound for correct qnum  :
    It will check the validation of props.params.qnum. If not, move to default_question=0.
*/
function mapStateToProps(state, props) {
  //console.log("mapStateToProps");
  //console.log(state);
  //console.log(props);
  const {isquizready}=state.quiz;
  if(isquizready){
    var qnum  = parseInt(props.match.params.qnum,10)  //From react-router
    const quizsize=state.quiz.data.length
    if( qnum<quizsize && qnum >= 0){
      const {qtext,choices,youtubeID,ans}=state.quiz.data[qnum]
      const qID=state.quiz.data[qnum].ID
      const {select,correct}=state.quiz.result[qnum]
      const in_bound = true
      return {
        quizID,
        isquizready,
        quizsize,
        qnum,
        correct,
        select,
        qID,
        qtext,
        choices,
        ans,
        youtubeID,
        in_bound
      }
    }
    else{
      const in_bound=false
      return {
        quizID,
        isquizready,
        qnum,
        in_bound
      }
    }
  }
  else{
    //console.log('Not ready!')
    return {
      quizID,
      isquizready
    }
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchQuiz,
    push: routerActions.push,
    selectCheck,
    selectChoice,
    reportCheck,
    reportVideo
  }, dispatch)
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuizPage);



// WEBPACK FOOTER //
// ./src/containers/QuizPage.js